import create from 'zustand';
import { SECTIONS } from '../constants/sections';

type Section = {
    translation: string;
    id: SECTIONS;
    domId: string;
};
export type useUIStateStore = {
    sections: Section[];
    setSections: (sections: Section[]) => void;
};

export const useUIStateStore = create<useUIStateStore>((set) => ({
    sections: [],
    setSections: (sections) => {
        set(() => ({
            sections,
        }));
    },
}));
